import { useState } from 'react';
import { EyeIcon, EyeOffIcon } from '@/components/icons';

interface PasswordInputProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  placeholder?: string;
  label?: string;
  name?: string;
  error?: string;
  touched?: boolean;
}

export const PasswordInput = ({
  value,
  onChange,
  onBlur,
  onFocus,
  placeholder = '',
  label = 'Password',
  name = 'password',
  error,
  touched,
}: PasswordInputProps) => {
  const [showPassword, setShowPassword] = useState(false);
  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    setIsFocused(true);
    onFocus?.(e);
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    setIsFocused(false);
    onBlur?.(e);
  };

  const shouldShowError = touched && error && !isFocused;

  return (
    <fieldset className="fieldset mb-2">
      <legend className="fieldset-legend input-label">{label}</legend>
      <div
        className={`
          join rounded-sm lg:h-9
          border border-[var(--color-input-border)]
          ${
            shouldShowError
              ? 'border-input-error'
              : 'focus-within:border-[var(--color-input-border-focus)]'
          }
        `}
      >
        <input
          type={showPassword ? 'text' : 'password'}
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onBlur={handleBlur}
          onFocus={handleFocus}
          className={`input text-input-password join-item border-r-0 pr-0 w-full focus:outline-none ${shouldShowError ? 'text-input-error' : ''}`}
        />
        <span
          className="btn border-0 h-full btn-show-hide-password join-item p-1"
          onClick={() => setShowPassword(!showPassword)}
        >
          {showPassword ? <EyeOffIcon /> : <EyeIcon />}
        </span>
      </div>

      {shouldShowError ? <span className="input-error">{error}</span> : <></>}
    </fieldset>
  );
};
